import { Box, type BoxProps, Text, Indicator } from '@mantine/core'
import { clsx } from 'clsx'
import Link from 'next/link'
import { type PropsWithChildren } from 'react'

import { useMenus } from '../../hooks/useMenus'
import classes from './styles.module.css'

export function NavbarSub({ className }: PropsWithChildren<BoxProps>) {
  const { menus, shouldRenderNavbarSub } = useMenus()
  const { pathname } = window.location
  const navbarSubClasses = clsx(classes.navbarSubWrapper, className)

  if (!shouldRenderNavbarSub) {
    return <></>
  }

  return (
    <Box className={navbarSubClasses}>
      {menus.map((menu) => {
        if (!menu.child) {
          return false
        }

        return (
          <>
            <Text size='lg' fw='bold' color='gray.4' mt='sm' mb='sm' pl='md'>
              {menu.label}
            </Text>
            {menu.child?.map((item) => {
              if (item.omit) {
                return <></>
              }

              return (
                <Link
                  key={`navbar-sub-${item.path}`}
                  href={item.path}
                  className={clsx(classes.navbarSubItem, {
                    [classes.navbarItemActive]:
                      (pathname === '/' && item.path === '/') ||
                      (item.path !== '/' && pathname === item.path),
                  })}
                >
                  <Indicator
                    disabled={!item.indicator}
                    color='orange'
                    position='middle-end'
                    size={8}
                  >
                    {item.label}
                  </Indicator>
                </Link>
              )
            })}
          </>
        )
      })}
    </Box>
  )
}
